
export default {
  favorites(state, getters, rootState, rootGetters) {
    let contacts = filterContacts(state);
    return contacts.filter(c => c.isFavorite);
  }
};

function filterContacts(state) {
  let nameFilter = state.filter.name;
  let contacts = Array.from(Object.values(state.contacts));
  return contacts.filter(c => {
    if (nameFilter && c.displayName && c.displayName.indexOf(nameFilter) < 0) {
      return false;
    }

    return true;
  });
}